package ru.notamedia.qah.managers

import ru.notamedia.qah.models.JsonValidationIssue

object JsonValidationReporter {

    fun generateReport(issues: List<JsonValidationIssue>): String {
        if (issues.isEmpty()) return "JSON соответствует ожидаемой структуре."

        val builder = StringBuilder()
        builder.appendLine("Несовпадения в JSON:\n")

        issues.forEachIndexed { index, issue ->
            val prefix = "${index + 1}."
            val line = when (issue) {
                is JsonValidationIssue.MissingField ->
                    "$prefix Отсутствует ожидаемое поле \"${issue.path}\""

                is JsonValidationIssue.UnexpectedField ->
                    "$prefix Лишнее поле \"${issue.path}\" в ответе"

                is JsonValidationIssue.TypeMismatch ->
                    "$prefix Поле \"${issue.path}\": ожидается тип ${issue.expectedType}, но получено ${issue.actualType}"
            }
            builder.appendLine("  $line")
        }

        return builder.toString()
    }
}
